import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const ZoomReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="zoomReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="zoomReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="zoomReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="zoomReaderFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.onError?.message}
      >
        <option value="">Select On Error</option>
        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>
      <FormField
        controlId="zoomReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter connection key"
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="zoomReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter parameterization"
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="zoomReaderFormPath"
        label="path"
        name="properties.path"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Path"
        required
        error={errors?.properties?.path?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default ZoomReaderForm;
